export default {
  general: {
    true: 'Sí',
    false: 'No',
  },
  date: {
    month: {
      1: 'Enero',
      2: 'Febrero',
      3: 'Marzo',
      4: 'Abril',
      5: 'Mayo',
      6: 'Junio',
      7: 'Julio',
      8: 'Agosto',
      9: 'Septiembre',
      10: 'Octubre',
      11: 'Noviembre',
      12: 'Diciembre',
    },
  },
  landing: {
    testimonials: {
      whitnessType: {
        maker: 'Marca',
        shop: 'Tienda',
      },
    },
    frequentQuestions: {
      kind: {
        maker: 'Marca',
        shop: 'Tienda',
      },
    },
  },
  order: {
    status: {
      draft: 'borrador',
      pending: 'pendiente',
      financiallyApproved: 'confirmación pendiente',
      confirmed: 'confirmada',
      deliveryInProgress: 'en despacho',
      delivered: 'entregada',
    },
    paymentStatus: {
      created: 'por facturar',
      billed: 'facturada',
      partiallyPaid: 'pago parcial',
      paid: 'pagada',
    },
    returnStatus: {
      noReturn: 'sin devolución',
      returnInProgress: 'devolución en proceso',
      partialReturn: 'devolución parcial',
      fullReturn: 'devolución total',
    },
    paymentMethod: {
      transferLater: 'pago a 60 días',
      cardNow: 'pago con tarjeta',
      transferNow: 'transferencia inmediata',
      payIn30Days: 'pago a 30 días',
      payIn15Days: 'pago a 15 días',
    },
  },
  subOrder: {
    paymentStatus: {
      paid: 'pagado',
      unpaid: 'pendiente',
      underReview: 'en revisión',
    },
    status: {
      draft: 'borrador',
      pending: 'pendiente',
      confirmed: 'despacho pendiente',
      deliveryInProgress: 'en despacho',
      delivered: 'entregado',
      readyForPickup: 'listo para retiro',
    },
    modificationsStatus: {
      noModifications: 'sin modificaciones',
      inProgress: 'en proceso',
      resolved: 'resuelta',
    },
    shipmentMethod: {
      lokal: 'Lokal',
      maker: 'Marca',
      shopPickup: 'Retiro en tienda',
    },
  },
  shop: {
    kind: {
      physicalStore: 'Tienda física',
      onlineStore: 'Tienda online',
      personalConsumption: 'Consumo personal',
      other: 'Otro',
      physicalAndOnlineStore: 'Tienda física y online',
      user: 'Usuario',
    },
  },
  orderPayment: {
    kind: {
      payment: 'pago de orden',
      delivery: 'despacho',
      return: 'devolución',
      smartPayment: 'pago de orden',
    },
  },
  shopPayment: {
    kind: {
      payment: 'pago de orden',
      delivery: 'despacho',
      return: 'devolución',
      smartPayment: 'pago de orden/es',
    },
  },
  product: {
    status: {
      active: 'activo',
      outOfStock: 'sin stock',
      inactive: 'inactivo',
    },
    shelfLifeUnit: {
      days: 'días',
      months: 'meses',
    },
  },
  billingInformation: {
    businessRut: 'RUT',
    commercialBusiness: 'Giro comercial',
    socialReason: 'Razón social',
    contactEmail: 'Email de contacto',
    addressId: 'Dirección',
    bankId: 'Banco',
    account: 'Número de cuenta',
    accountType: 'Tipo de cuenta',
  },
  freeShippingInvoice: {
    paymentStatus: {
      unpaid: 'Sin pagar',
      paid: 'Pagado',
    },
  },
  incidenceReport: {
    status: {
      incidenceInProgress: 'En proceso',
      incidenceResolved: 'Resuelta',
    },
  },
  referredContacts: {
    kind: {
      physicalStore: 'Tienda física',
      onlineStore: 'Tienda online',
      physicalAndOnlineStore: 'Tienda física y online',
      other: 'Otro',
      personalConsumption: 'Consumo personal',
    },
  },
};
